import iconPath from '@/assets/device-icons/iphone-14-pro.svg';

interface Iphone14ProIconProps {
  className?: string;
}

export const Iphone14ProIcon = ({ className = "h-5 w-5" }: Iphone14ProIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iPhone 14 Pro" 
      className={className}
    />
  );
};
